import NaverMap, { NaverMapMarkerItem } from './BaseMap';

export interface ReservationRouteSlot {
  id: number;
  shopId: number;
  shopName: string;
  roomName: string;
  address?: string | null;
  lat?: number;
  lng?: number;
  lon?: number;
  time: string;
  endTime: string;
}

interface RouteNaverMapProps {
  clientId: string;
  slots: ReservationRouteSlot[];
  activeIndex: number | null;
  onSlotSelect: (index: number) => void;
  zoomLevel: number;
  minHeight?: number;
  onZoomLevelChange: (zoom: number) => void;
  className?: string;
  style?: React.CSSProperties;
}

function getShortName(name: string) {
  if (!name) return '';
  return name.replace(/\s/g, '').slice(0, 2);
}

export default function ShopNaverMap({
  clientId,
  slots,
  activeIndex,
  onSlotSelect,
  zoomLevel,
  minHeight,
  onZoomLevelChange,
  className,
  style,
}: RouteNaverMapProps) {
  const slotsWithCoords = slots.filter(
    (slot) =>
      typeof slot.lat === 'number' &&
      typeof (slot.lng ?? slot.lon) === 'number'
  );
  
  const markers: NaverMapMarkerItem[] = slotsWithCoords.map((slot, index) => {
    const shortName = getShortName(slot.shopName);

    return {
      id: slot.id,
      name: slot.shopName,
      shortName,
      lat: Number(slot.lat),
      lng: Number(slot.lng ?? slot.lon),

      // ❌ order 제거

      // ✅ 커스텀 마커 UI (앞글자 2글자)
      icon: {
        content: `
          <div style="
            width:32px;
            height:32px;
            border-radius:50%;
            display:flex;
            align-items:center;
            justify-content:center;
            font-size:12px;
            font-weight:700;
            background:white;
            border:2px solid #2563eb;
            color:#2563eb;
            box-shadow:0 2px 6px rgba(0,0,0,0.15);
          ">
            ${shortName}
          </div>
        `,
        // anchor: new window.naver.maps.Point(16, 16),
      },

      html: `
        <div style="padding:10px 12px; min-width:150px;">
          <div style="font-size:13px; font-weight:700; margin-bottom:4px;">
            ${slot.shopName}
          </div>

        </div>
      `,
    };
  });

  const selectedMarkerId =
    activeIndex !== null && slotsWithCoords[activeIndex]
      ? slotsWithCoords[activeIndex].id
      : null;

  return (
    <div className={className} style={style}>
      <NaverMap
        clientId={clientId}
        markers={markers}
        selectedMarkerId={selectedMarkerId}
        autoFit={markers.length >= 2}
        zoom={zoomLevel}
        connectLine={false}
        // ❌ connectLine 완전 제거
        onMapClick={() => onSlotSelect(null)}
        onMarkerClick={(_, index) => onSlotSelect(index)}
        onZoomChanged={onZoomLevelChange}
        minHeight={minHeight}
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
}